import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarMetodo } from '../../../actions/configuracion';

const EliminarMetodo = ({ metodo, handleCerrar }) => {

    const dispatch = useDispatch();

    const [eliminarModal, setEliminarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    useEffect(() => {
        setEliminarModal(metodo ? true : false);
    }, [metodo]);

    const handleProcesar = async () => {
        setStatusProcesar(true);
        await dispatch(eliminarMetodo(metodo._id));
        setStatusProcesar(false);
        handleCerrar();
    };

    const handleClose = () => {
        setEliminarModal(false);
        handleCerrar();
    };

    return (
        <Modal show={eliminarModal} backdrop="static" centered onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar método</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Deseas eliminar el método <b>{metodo?.nombre || ''}</b>? Esta acción no se puede deshacer.</p>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary" onClick={handleClose} disabled={statusProcesar}>
                    No
                </button>
                {
                    statusProcesar
                        ? <button className="btn btn-danger" disabled><span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span> Sí</button>
                        : <button className="btn btn-danger" onClick={handleProcesar}>Sí</button>
                }
            </Modal.Footer>
        </Modal>
    );
};

export default EliminarMetodo;
